import { PrinterPosOutlineIcon } from './PrinterPosOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4206F292-9583-42F9-91CD-2DEA9F273C9F
 * name printer-pos-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptOutlineIcon = PrinterPosOutlineIcon;
export default PrinterReceiptOutlineIcon